<nav style="z-index: 1040; position: relative" class="navbar navbar-expand-md navbar-dark bg-primary">
  <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <a class="navbar-brand" routerLink="/">{{ intranet.name }}</a>
    <div class="development-clock-controls" *ngIf="showDevelopmentClockControls">
      <span class="development-clock-label">Development clock:</span>
      <button type="button" class="btn btn-outline-light btn-sm" *ngFor="let preset of developmentClockPresets"
        [disabled]="developmentClockBusy" (click)="setDevelopmentClock(preset)">{{ developmentClockLabel(preset) }}</button>
      <button type="button" class="btn btn-warning btn-sm" [disabled]="developmentClockBusy" (click)="resetDevelopmentClock()">Real time</button>
      <span class="development-clock-current" *ngIf="developmentClockCurrent">({{ developmentClockCurrent }})</span>
    </div>
    <ul class="navbar-nav mr-auto" style="flex-wrap: wrap !important">
      <ng-container *ngFor="let navItem of navBarStructure">
        <li [class]="'nav-item' + (navItem.children ? ' dropdown' : '')" *ngIf="navItem.show" style="white-space: nowrap !important">
          <a [href]="navItem.url" *ngIf="navItem.url && navItem.children" class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i *ngIf="navItem.icon" class="fas {{ navItem.icon }} mr-1"></i>{{ navItem.name }}
          </a>
          <a [href]="navItem.parseURL" *ngIf="navItem.parseURL && !navItem.navbar_sidekiq && navItem.children" class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i *ngIf="navItem.icon" class="fas {{ navItem.icon }} mr-1"></i>{{ navItem.name }}
          </a>
          <a [routerLink]="navItem.routerURL" *ngIf="navItem.routerURL && !navItem.navbar_sidekiq && navItem.children" class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i *ngIf="navItem.icon" class="fas {{ navItem.icon }} mr-1"></i>{{ navItem.name }}
          </a>
          <a [href]="navItem.url" *ngIf="navItem.url && !navItem.children" [attr.target]="navItem.target || null" [attr.rel]="navItem.target === '_blank' ? 'noopener' : null" class="nav-link" aria-haspopup="true" aria-expanded="false">
            <i *ngIf="navItem.icon" class="fas {{ navItem.icon }} mr-1"></i>{{ navItem.name }}
          </a>
          <a [href]="navItem.parseURL" *ngIf="navItem.parseURL && !navItem.navbar_sidekiq && !navItem.children" class="nav-link" aria-haspopup="true" aria-expanded="false">
            <i *ngIf="navItem.icon" class="fas {{ navItem.icon }} mr-1"></i>{{ navItem.name }}
          </a>
          <a [routerLink]="navItem.routerURL" *ngIf="navItem.routerURL && !navItem.navbar_sidekiq && !navItem.children" class="nav-link" aria-haspopup="true" aria-expanded="false">
            <i *ngIf="navItem.icon" class="fas {{ navItem.icon }} mr-1"></i>{{ navItem.name }}
          </a>
          <ul *ngIf="navItem.children" class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <ng-container *ngFor="let navChildItem of navItem.children">
              <li *ngIf="navChildItem.show && !navChildItem.navbar_sidekiq" [class]="'dropdown-item' + (navChildItem.children ? ' dropdown-submenu' : '')">
                <a *ngIf="navChildItem.url && !navChildItem.forceReload" [href]="navChildItem.url" [attr.target]="navChildItem.target || null">{{ navChildItem.name }}</a>
                <a *ngIf="navChildItem.url && navChildItem.forceReload" href="#" (click)="forceReload($event, navChildItem.url)">{{ navChildItem.name }}</a>
                <a *ngIf="navChildItem.parseURL && !navChildItem.navbar_sidekiq" href="#" (click)="forceReload($event, navChildItem.parseURL)">{{ navChildItem.name }}</a>
                <a *ngIf="navChildItem.routerURL && !navChildItem.navbar_sidekiq" [routerLink]="navChildItem.routerURL">{{ navChildItem.name }}</a>
                <ul *ngIf="navChildItem.children" class="dropdown-menu">
                  <ng-container *ngFor="let navChild1 of navChildItem.children">
                    <li *ngIf="navChild1.show" [class]="'dropdown-item' + (navChild1.children ? ' dropdown-submenu' : '')">
                      <a *ngIf="navChild1.url" [href]="navChild1.url">{{ navChild1.name }}</a>
                      <a *ngIf="navChild1.parseURL && !navChild1.navbar_sidekiq" href="#" (click)="forceReload($event, navChild1.parseURL)">{{ navChild1.name }}</a>
                      <a *ngIf="navChild1.routerURL && !navChild1.navbar_sidekiq" [routerLink]="navChild1.routerURL">{{ navChild1.name }}</a>
                      <ul *ngIf="navChild1.children" class="dropdown-menu">
                        <ng-container *ngFor="let navChild2 of navChild1.children">
                          <li *ngIf="navChild2.show" [class]="'dropdown-item' + (navChild2.children ? ' dropdown-submenu' : '')">
                            <a *ngIf="navChild2.url" [href]="navChild2.url">{{ navChild2.name }}</a>
                            <a *ngIf="navChild2.parseURL && !navChild2.navbar_sidekiq" href="#" (click)="forceReload($event, navChild2.parseURL)">{{ navChild2.name }}</a>
                            <a *ngIf="navChild2.routerURL && !navChild2.navbar_sidekiq" [routerLink]="navChild2.routerURL">{{ navChild2.name }}</a>
                            <ul *ngIf="navChild2.children" class="dropdown-menu">
                              <ng-container *ngFor="let navChild3 of navChild2.children">
                                <li *ngIf="navChild3.show" [class]="'dropdown-item' + (navChild3.children ? ' dropdown-submenu' : '')">
                                  <a *ngIf="navChild3.url" [href]="navChild3.url">{{ navChild3.name }}</a>
                                  <a *ngIf="navChild3.parseURL && !navChild3.navbar_sidekiq" href="#" (click)="forceReload($event, navChild3.parseURL)">{{ navChild3.name }}</a>
                                  <a *ngIf="navChild3.routerURL && !navChild3.navbar_sidekiq" [routerLink]="navChild3.routerURL">{{ navChild3.name }}</a>
                                  <ul *ngIf="navChild3.children" class="dropdown-menu">
                                    <ng-container *ngFor="let navChild4 of navChild3.children">
                                      <li *ngIf="navChild4.show" [class]="'dropdown-item' + (navChild4.children ? ' dropdown-submenu' : '')">
                                        <a *ngIf="navChild4.url" [href]="navChild4.url">{{ navChild4.name }}</a>
                                        <a *ngIf="navChild4.parseURL && !navChild4.navbar_sidekiq" href="#" (click)="forceReload($event, navChild4.parseURL)">{{ navChild4.name }}</a>
                                        <a *ngIf="navChild4.routerURL && !navChild4.navbar_sidekiq" [routerLink]="navChild4.routerURL">{{ navChild4.name }}</a>
                                      </li>
                                    </ng-container>
                                  </ul>
                                </li>
                              </ng-container>
                            </ul>
                          </li>
                        </ng-container>
                      </ul>
                    </li>
                  </ng-container>
                </ul>
              </li>
              <li *ngIf="navChildItem.navbar_sidekiq && navChildItem.show" class="dropdown-submenu dropdown-item">
                <a href="#">Sidekiq</a>
                <ul class="dropdown-menu">
                  <li *ngIf="sidekiqInfo" class="dropdown-item" [ngClass]="{ 'dropdown-submenu': sidekiqInfo.processset_size > 0 }">
                    <a href="#">{{ sidekiqInfo.processset_size > 0 ? 'Sidekiq is running' : 'Sidekiq is not running' }}</a>
                    <ul class="dropdown-menu">
                      <ng-container *ngFor="let processSet of sidekiqInfo.processsets">
                        <li class="dropdown-item">
                          <a>Queues: {{ processSet.queues }}</a>
                        </li>
                        <li class="dropdown-item">
                          <a>&nbsp;&nbsp;&nbsp;&nbsp;Busy: {{ processSet.busy }}</a>
                        </li>
                        <li class="dropdown-item">
                          <a>&nbsp;&nbsp;&nbsp;&nbsp;Started: {{ processSet.started }}</a>
                        </li>
                        <li class="dropdown-item">
                          <a>&nbsp;&nbsp;&nbsp;&nbsp;PID: {{ processSet.pid }}</a>
                        </li>
                      </ng-container>
                    </ul>
                  </li>
                  <li class="dropdown-item" *ngIf="sidekiqInfo && sidekiqInfo.processset_size < 1">
                    <a href="#" (click)="startSidekiq()"> Start Sidekiq </a>
                  </li>
                  <li class="dropdown-item" *ngIf="sidekiqInfo">
                    <a href="#" (click)="clearCountersSidekiq()"> Clear Counters </a>
                  </li>
                  <li class="dropdown-item" *ngIf="sidekiqInfo">
                    <a href="#" (click)="clearResetQueueSidekiq()"> Clear Reset Queue </a>
                  </li>
                  <li class="dropdown-item" *ngIf="sidekiqInfo">
                    <a href="/sidekiq_web" target="_blank"> Sidekiq Status </a>
                  </li>
                  <li class="dropdown-item" *ngIf="sidekiqInfo && sidekiqInfo.processset_size > 0">
                    <a href="#" (click)="killSidekiq()"> Kill Sidekiq </a>
                  </li>
                  <li class="dropdown-item">
                    <a routerLink="/sidekiq"> Sidekiq Cron </a>
                  </li>
                </ul>
              </li>
            </ng-container>
          </ul>
        </li>
      </ng-container>
    </ul>
    <ul class="navbar-nav" style="flex-wrap: wrap !important">
      <li class="nav-item">
        <a
          routerLink="/scans"
          class="nav-link scan-queue-status-link"
          [title]="'Open scan queue: ' + scanQueueOpenCount + ' open, ' + scanQueuePendingCount + ' pending'"
        >
          <i class="fas fa-inbox mr-1" [ngClass]="{ 'text-warning': scanQueueOpenCount > 0 }"></i>
          <span class="scan-queue-status-text">Scans</span>
          <span class="scan-queue-status-badge" [ngClass]="{ 'scan-queue-status-badge-active': scanQueueOpenCount > 0 }">{{ scanQueueOpenCount }}</span>
        </a>
      </li>
      <li class="nav-item">
        <a href="#" (click)="$event.preventDefault(); logout()" class="nav-link" data-method="delete">Logout</a>
      </li>
    </ul>
    <form class="form-inline my-2 my-lg-0" style="flex-wrap: wrap !important">
      <input class="form-control ml-2 mr-sm-2" type="text" name="matter_number" [(ngModel)]="matter_number" (keyup.enter)="openMatter()" (keyup.control.enter)="openMatter(true)" placeholder="Matter #" />
    </form>
  </div>
</nav>
<nav class="navbar navbar-expand-md navbar-dark bg-primary" style="min-height: 56px !important">
  <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarSupportedContent2" aria-controls="navbarSupportedContent2" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarSupportedContent2">
    <ul class="navbar-nav mr-auto" style="flex-wrap: wrap !important">
      <ng-container *ngFor="let navItem of secondMenu">
        <li [class]="'nav-item' + (navItem.children ? ' dropdown' : '')" *ngIf="navItem.show" style="white-space: nowrap !important">
          <a [href]="navItem.url" *ngIf="navItem.url && navItem.children" class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{ navItem.name }}
          </a>
          <a [href]="navItem.parseURL" *ngIf="navItem.parseURL && !navItem.navbar_sidekiq && navItem.children" class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{ navItem.name }}
          </a>
          <a [routerLink]="navItem.routerURL" *ngIf="navItem.routerURL && !navItem.navbar_sidekiq && navItem.children" class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{ navItem.name }}
          </a>
          <a [href]="navItem.url" *ngIf="navItem.url && !navItem.children" [attr.target]="navItem.target || null" [attr.rel]="navItem.target === '_blank' ? 'noopener' : null" class="nav-link" aria-haspopup="true" aria-expanded="false">
            {{ navItem.name }}
          </a>
          <a [href]="navItem.parseURL" *ngIf="navItem.parseURL && !navItem.navbar_sidekiq && !navItem.children" class="nav-link" aria-haspopup="true" aria-expanded="false">
            {{ navItem.name }}
          </a>
          <a [routerLink]="navItem.routerURL" *ngIf="navItem.routerURL && !navItem.navbar_sidekiq && !navItem.children" class="nav-link" aria-haspopup="true" aria-expanded="false">
            {{ navItem.name }}
          </a>
          <a class="nav-link ical-copy-link" style="cursor: pointer" aria-haspopup="true" aria-expanded="false" (click)="copyIcal()" *ngIf="navItem.clipboard">
            <i *ngIf="icalCopying" class="fas fa-spinner fa-spin" aria-hidden="true"></i>
            <i *ngIf="icalCopied" class="fas fa-check" aria-hidden="true"></i>
            <span>{{ icalCopying ? 'Copying iCal URL…' : (icalCopied ? 'iCal URL copied' : navItem.name) }}</span>
          </a>
          <ul *ngIf="navItem.children" class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <ng-container *ngFor="let navChildItem of navItem.children">
              <li *ngIf="navChildItem.show" [class]="'dropdown-item' + (navChildItem.children ? ' dropdown-submenu' : '')">
                <a *ngIf="navChildItem.url" [href]="navChildItem.url" [attr.target]="navChildItem.target || null">{{ navChildItem.name }}</a>
                <a *ngIf="navChildItem.parseURL && !navChildItem.navbar_sidekiq" href="#" (click)="forceReload($event, navChildItem.parseURL)">{{ navChildItem.name }}</a>
                <a *ngIf="navChildItem.routerURL && !navChildItem.navbar_sidekiq" [routerLink]="navChildItem.routerURL">{{ navChildItem.name }}</a>
                <ul *ngIf="navChildItem.children" class="dropdown-menu">
                  <li *ngFor="let navChild1 of navChildItem.children" [class]="'dropdown-item' + (navChild1.children ? ' dropdown-submenu' : '')">
                    <a *ngIf="navChild1.url" [href]="navChild1.url">{{ navChild1.name }}</a>
                    <a *ngIf="navChild1.parseURL && !navChild1.navbar_sidekiq" href="#" (click)="forceReload($event, navChild1.parseURL)">{{ navChild1.name }}</a>
                    <a *ngIf="navChild1.routerURL && !navChild1.navbar_sidekiq" [routerLink]="navChild1.routerURL">{{ navChild1.name }}</a>
                    <ul *ngIf="navChild1.children" class="dropdown-menu">
                      <li *ngFor="let navChild2 of navChild1.children" [class]="'dropdown-item' + (navChild2.children ? ' dropdown-submenu' : '')">
                        <a *ngIf="navChild2.url" [href]="navChild2.url">{{ navChild2.name }}</a>
                        <a *ngIf="navChild2.parseURL && !navChild2.navbar_sidekiq" href="#" (click)="forceReload($event, navChild2.parseURL)">{{ navChild2.name }}</a>
                        <a *ngIf="navChild2.routerURL && !navChild2.navbar_sidekiq" [routerLink]="navChild2.routerURL">{{ navChild2.name }}</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ng-container>
          </ul>
        </li>
      </ng-container>
    </ul>
    <ul class="navbar-nav ml-auto">
      <li class="nav-item dropdown" *ngIf="canSwitchIntranets && selectedIntranet && availableIntranets">
        <a href="#" class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          {{ selectedIntranet.label }}
        </a>
        <ul class="dropdown-menu">
          <li *ngFor="let availableIntranet of availableIntranets" class="dropdown-item">
            <a href="#" (click)="$event.preventDefault();switchIntranet(availableIntranet)" class="nav-link" aria-haspopup="true" aria-expanded="false">
              {{ availableIntranet.label }}
            </a>
          </li>
        </ul>
      </li>
      <li class="nav-item dropdown" *ngIf="switchableUsers.length > 0 || userSwitchActive">
        <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fas fa-user-secret mr-1"></i>{{ userSwitchActive ? 'Working as ' + user.name : 'Switch user' }}
        </a>
        <ul class="dropdown-menu">
          <li *ngIf="userSwitchActive"><a href="#" class="dropdown-item" (click)="$event.preventDefault();switchUserBack()">Return to {{ originalUserName }}</a></li>
          <li *ngFor="let switchableUser of switchableUsers">
            <a href="#" class="dropdown-item" (click)="$event.preventDefault();switchUser(switchableUser.id)">{{ switchableUser.name }}</a>
          </li>
        </ul>
      </li>
      <li class="nav-item" title="Sidekiq is not running, can be started through v6 menu" *ngIf="showSidekiqNotRunning && sidekiqInfo && sidekiqInfo.processset_size < 1">
        <a class="nav-link" style="height: 40px !important; padding-top: 12px !important; padding-bottom: 12px !important" href="#"><i class="fas fa-server text-danger"></i>&nbsp;<s>Sidekiq</s></a>
      </li>
      <li class="nav-item" *ngIf="appointmentRequestsData && appointmentRequestsData.current_user_handles_appointment && appointmentRequestsData.apt_requests_pending.length > 0">
        <a
          [title]="'View Pending Apt Req'"
          href="#"
          class="nav-link"
          style="height: 40px !important; padding-top: 12px !important; padding-bottom: 12px !important"
          (click)="openAppointmentRequests($event, appointmentRequestsData.apt_requests_pending)"
        >
          <i class="fas fa-tasks text-danger"></i>&nbsp;{{ appointmentRequestsData.apt_requests_pending.length }}
        </a>
      </li>
      <li class="nav-item" *ngIf="appointmentRequestsData && appointmentRequestsData.current_user_handles_appointment && appointmentRequestsData.apt_requests_making_contact.length > 0">
        <a
          [title]="'View Making Contact Apt Req'"
          href="#"
          class="nav-link"
          style="height: 40px !important; padding-top: 12px !important; padding-bottom: 12px !important"
          (click)="openAppointmentRequests($event, appointmentRequestsData.apt_requests_making_contact)"
        >
          <i class="fas fa-tasks text-light"></i>&nbsp;{{ appointmentRequestsData.apt_requests_making_contact.length }}
        </a>
      </li>
      <li class="nav-item" *ngIf="appointmentRequestsData && appointmentRequestsData.current_user_handles_appointment && appointmentRequestsData.apt_requests_to_be_rescheduled.length > 0">
        <a
          [title]="'View To Be Rescheduled Apt Req'"
          href="#"
          class="nav-link"
          style="height: 40px !important; padding-top: 12px !important; padding-bottom: 12px !important"
          (click)="openAppointmentRequests($event, appointmentRequestsData.apt_requests_to_be_rescheduled)"
        >
          <i class="fas fa-tasks text-warning"></i>&nbsp;{{ appointmentRequestsData.apt_requests_to_be_rescheduled.length }}
        </a>
      </li>
      <li class="nav-item">
        <a
          [title]="newNotificationsPresent ? 'New notifications' : 'View Notifications'"
          href="#"
          class="nav-link"
          style="height: 40px !important; padding-top: 12px !important; padding-bottom: 12px !important"
          (click)="$event.preventDefault(); $event.stopImmediatePropagation(); showNotifications = !showNotifications; newNotificationsPresent = false; updateNotifications()"
        >
          <i class="fas fa-bell" [ngClass]="{ animated: newNotificationsPresent, infinite: newNotificationsPresent, swing: newNotificationsPresent, 'text-warning': newNotificationsPresent || pendingNotificationsPresent }"></i>
        </a>
      </li>
      <li class="nav-item">
        <a [routerLink]="'/users/' + user.id + '/edit'" class="nav-link">{{ user.name }}({{ user.id }})</a>
      </li>
    </ul>
  </div>
</nav>
<app-breadcrumbs></app-breadcrumbs>
<!-- Notifications -->
<div [hidden]="!showNotifications" class="bg-white shadow-lg" style="position: fixed; right: 0px; top: 0px; height: 100%; width: 400px; max-width: 100% !important; z-index: 1039; overflow-y: scroll !important">
  <h3 class="border-bottom p-3 font-weight-normal">
    <a class="text-dark font-weight-light float-right" style="cursor: pointer" (click)="$event.preventDefault(); $event.stopImmediatePropagation(); showNotifications = !showNotifications">
      <span class="ti-close"></span>
    </a>
    Notifications
  </h3>
  <div class="p-3">
    <app-reminder-common [notificationMode]="true" [notyPosition]="'center'"></app-reminder-common>
  </div>
</div>
<app-appointment-requests-sidebar
  [appointmentRequestsToView]="appointmentRequestsToView"
  [(showAptReq)]="showAptReq"
></app-appointment-requests-sidebar>
